import { ApiService } from './apiService';
import { NavSettings } from '../types';

export class NavSettingsService extends ApiService {

  private static readonly _instance = new NavSettingsService();

  private constructor() { super('', true); }

  static get instance() { return this._instance; }

  async updateNavSettings(settings: NavSettings): Promise<any> {
    return this.fetchPut(`/users/nav-settings`, {
      settings: JSON.stringify(settings)
    });
  }
}
